import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAppResponse, IPagedResult } from '../../_models/network-response';
import { IAppliedJob } from './applied-job.model';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class AppliedJobService {

  private endpoint: string = "applied-job";

  constructor(private apiService: ApiService) { }

  createAppliedJob(formData: FormData): Observable<any> {
    return this.apiService.post<FormData, object>({
      Url: `${this.endpoint}`,
      Body: formData
    });
  }

  getAllAppliedJobs(pageNumber: number, pageSize: number): Observable<IAppResponse<IPagedResult<IAppliedJob>>> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.apiService.getAllPageed<IAppliedJob>({
      Url: `${this.endpoint}/all`,
      Params: params
    });
  }

  getAppliedJobById(id: string) {
    return this.apiService.get<IAppliedJob>({
      Url: `${this.endpoint}/${id}`
    });
  }

  deleteAppliedJob(id: string) {
    return this.apiService.delete<object, object>({
      Url: `${this.endpoint}/${id}`,
      Body: {}
    });
  }
}